import { IFilterValue } from 'types/filters/common';

import { filtersFormatter } from './formatters';

export function filtersToValues({ filters }: { filters: IFilterValue[] }) {
  const reversedFilters = [...filters].reverse();

  const values = reversedFilters.map(el =>
    filtersFormatter({
      filter: el,
      formatter: el.scheme?.formatter,
    }),
  );

  const valuesReduced = values.reduce((acc, val) => {
    const key = Object.keys(val)[0];

    if (!key || !val[key]) return acc;

    return { ...acc, [key]: acc[key] ? acc[key].concat([val[key]]) : [val[key]] };
  }, {}) as Record<string, any[]>;

  return valuesReduced;
}
